import { Icon } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import styled from 'styled-components';

export const FileIcon = styled(Icon)`
	color: ${globalVars.secondaryGreen};
	margin-right: ${globalVars.spacing10};
`;
FileIcon.displayName = 'FileIcon';

export const DisabledFileIcon = styled(Icon)`
	color: ${globalVars.gray7};
	margin-right: ${globalVars.spacing10};
`;
DisabledFileIcon.displayName = 'DisabledFileIcon';

export const NameLinkWrapper = styled.div.attrs<ITableLinkWrapperProps>({})<ITableLinkWrapperProps>`
	${(props) =>
		!props.disabled
			? `
	&:hover {
		color: #000000;
		cursor: pointer;
		i {
			color: #017c44;
		}
	}`
			: ''};
	position: relative;
	min-height: 40px;
	padding-top: 10px;
`;

export interface ITableLinkWrapperProps {
	disabled?: boolean;
	onClick?(): void;
}

export class TableLinkWrapper extends React.PureComponent<React.PropsWithChildren<ITableLinkWrapperProps>> {
	public render() {
		return (
			<NameLinkWrapper onClick={!this.props.disabled ? this.props.onClick : undefined} disabled={this.props.disabled}>
				{!this.props.disabled ? <FileIcon name='file' /> : <DisabledFileIcon name='file' />}
				{this.props.children}
			</NameLinkWrapper>
		);
	}
}
